import { getQueryKey } from '@trpc/react-query'
import { queryClient } from '../lib/query-client'
import { useTabsStore } from '../stores/tabs.store'
import { trpc } from '../lib/trpc'
import { dbgEvent } from '../lib/debug'

export const sessionHandler = {
  onSessionEvent(event: string, data: Record<string, unknown>): void {
    dbgEvent('Zustand', `session.onSessionEvent ${event}`, data)

    if (event === 'renamed') {
      const { sessionId, title } = data as { sessionId: string; title: string }
      // Mettre à jour l'onglet
      const tabs = useTabsStore.getState().tabs
      const tab = tabs.find(t => t.sessionId === sessionId)
      if (tab) {
        useTabsStore.getState().updateTabTitle(tab.id, title)
      }
      // Invalider sessions.list
      const key = getQueryKey(trpc.sessions.list, {}, 'query')
      void queryClient.invalidateQueries({ queryKey: key })
    } else if (event === 'created' || event === 'closed') {
      // Invalider sessions.list pour que la Sidebar se rafraîchisse
      const key = getQueryKey(trpc.sessions.list, {}, 'query')
      void queryClient.invalidateQueries({ queryKey: key })
    }
  },
}
